// Quando true, oculta o <Sidebar /> lateral e renderiza o menu antigo
// (AppMenuNav do CoreUI) dentro do DefaultHeader.
// Default: false (sidebar novo, header limpo).
export const LEGACY_NAV = false

// Seção "PROMOÇÃO IPIRANGA" do menu amarelo (REV-2144): já posicionada entre
// "A OFERTA É SUA" e "FINANCEIRO", mas oculta até a liberação. Mesmo em true,
// só aparece para postos com a promoção (hasPromocaoIpiranga).
export const SHOW_PROMOCAO_IPIRANGA_NAV = false
